var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJanejohnMarkRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 4.53018V0.680176H37.88V71.1002C30.6667 70.608 23.8487 67.6244 18.5925 62.6599C13.3364 57.6953 9.96887 51.0585 9.06627 43.885C8.16368 36.7115 9.78209 29.4473 13.6446 23.3354C17.507 17.2235 23.3735 12.6439 30.24 10.3802V5.82018C22.1731 8.12432 15.1813 13.208 10.5021 20.1714C5.82294 27.1349 3.75801 35.5292 4.67278 43.8687C5.58756 52.2082 9.42305 59.9553 15.5005 65.7388C21.5779 71.5224 29.5054 74.9695 37.88 75.4702V79.3202H42.23V8.91018C49.4194 9.42955 56.2068 12.4238 61.4373 17.3835C66.6679 22.3431 70.0185 28.9618 70.9191 36.1135C71.8196 43.2651 70.2146 50.5079 66.3769 56.6095C62.5393 62.7111 56.7062 67.2946 49.87 69.5802V74.1402C57.9098 71.8146 64.871 66.7262 69.5271 59.7714C74.1832 52.8167 76.2354 44.4419 75.3223 36.1224C74.4092 27.8029 70.5894 20.0726 64.5357 14.2933C58.482 8.51405 50.5829 5.05663 42.23 4.53018V4.53018Z",
    fill: "#5891CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJanejohnMarkRgb);
export default __webpack_public_path__ + "static/media/JANEJOHN_Mark_RGB.e5ee58f68cb695dd23274d6c022a365f.svg";
export { ForwardRef as ReactComponent };